module.exports = __webpack_public_path__ + "img/tur.31272e49.svg";